/*
###################################################################################### 
######################################################################################
 
########   #######        ## ########  ######  ########     ######  ##      ## ##     ## #### ########  ######## ########  
##     ## ##     ##       ## ##       ##    ##    ##       ##    ## ##  ##  ## ##     ##  ##  ##     ## ##       ##     ## 
##     ## ##     ##       ## ##       ##          ##       ##       ##  ##  ## ##     ##  ##  ##     ## ##       ##     ## 
########  ##     ##       ## ######   ##          ##        ######  ##  ##  ## ##     ##  ##  ########  ######   ########  
##        ##     ## ##    ## ##       ##          ##             ## ##  ##  ## ##     ##  ##  ##        ##       ##   ##   
##        ##     ## ##    ## ##       ##    ##    ##       ##    ## ##  ##  ## ##     ##  ##  ##        ##       ##    ##  
##         #######   ######  ########  ######     ##        ######   ###  ###   #######  #### ##        ######## ##     ## 

###################################################################################### 
######################################################################################
*/
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';

// Initialisiere Swiper
const swiper = new Swiper(".projectSwiper", {
  modules: [Navigation, Pagination, Keyboard],
  loop: true,
  pagination: {
    el: "#projectSwiper .swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: "#projectSwiper .swiper-button-next",
    prevEl: "#projectSwiper .swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false
  }

});
